import React, { Component} from "react";
import axios from "axios";
import { Redirect } from 'react-router-dom';

import { TabContent, TabPane, Nav, NavItem, NavLink, Card, CardBody, Button, CardTitle, CardText, Row, Col } from 'reactstrap';
import classnames from 'classnames';
import PropertyReportMain from "./PropertyReportMain";
import PropertyReportDeedMain from "./PropertyReportDeedMain";
import PropertyReportFiling from "./PropertyReportFiling";
import PropertyReportLienMain from "./PropertyReportLienMain";
import PropertyReportMrtgMain from "./PropertyReportMrtgMain";
import PropertyReportPay from "./PropertyReportPay";
import PropertyReportTaxMain from "./PropertyReportTaxMain";
import Banner from "../common/banner";

class PropertyRerportForm extends Component {
    constructor(...args) {
        super(...args);
        this.state = {
            showBanner: false, IsSuccess:false, message: '', activeTab: '1', OrderData: {
                Address: null,
                City: null,
                Zip:  null,
                State: null,
                BorrowerFirstName: null,
                BorrowerMiddleName:null,
                BorrowerLastName: null,
                BorrowerEmail: null,
                BorrowerPhone: null,
                AgentFirstName: null,
                AgentMiddleName:null,
                AgentLastName:  null,
                AgentEmail: null,
                AgentPhone: null,
            }
        };
    }
    componentDidMount() {
        axios.post(
            'https://api.mtsgrp.net/searchorder',
            JSON.stringify({ OrderId: this.props.location.Order.Id }),
            {
                headers:
                {
                    'Content-Type': 'application/json'
                }
            }
        ).then((response) => {
            var OrderData = JSON.parse(response.data.body);
            this.setState(prevState => ({
                ...prevState, OrderData: {
                    Address: OrderData[0].ADDRESS_LINE,
                    City: OrderData[0].CITY,
                    Zip: OrderData[0].ZIP,
                    State: OrderData[0].STATE,
                    BorrowerFirstName: OrderData[0].FIRSTNAME,
                    BorrowerMiddleName: OrderData[0].MIDDLENAME,
                    BorrowerLastName: OrderData[0].LASTNAME,
                    BorrowerEmail: OrderData[0].EMAIL,
                    BorrowerPhone: OrderData[0].MOBILEPHONE,
                    AgentFirstName: OrderData[0].AGENTFIRSTNAME,
                    AgentMiddleName: OrderData[0].AGENTMIDDLENAME,
                    AgentLastName: OrderData[0].AGENTLASTNAME,
                    AgentEmail: OrderData[0].AGENTEMAIL,
                    AgentPhone: OrderData[0].AGENTMOBILEPHONE,
                }
            }));
        })
    };

    
    toggle = tab => {
        if (this.state.activeTab !== tab)
            this.setState(prevState => ({
                ...prevState, activeTab: tab
            }));
    }

    showBanner = (IsSuccess, message) => {
        this.setState(prevState => ({
            ...prevState, showBanner: true, message, IsSuccess
        }));

    }
    closeBanner = () => {
        this.setState(prevState => ({
            ...prevState, showBanner: false
        }));

    }

    render() {

        if (!(this.props.location.Order)) 
        return <Redirect to="/order-create" />

       var proptab = [
            { Name: "Main", Id: "1" },
            { Name: "Deed", Id: "2" },
            { Name: "Mortgage", Id: "3" },
            { Name: "Lien", Id: "5" },
            { Name: "Tax", Id: "6" },
        ];

        var proptabitem = proptab.map((d) => <NavItem><NavLink
            className={classnames({ active: this.state.activeTab === d.Id })}
            onClick={() => { 
                this.toggle(d.Id); }}>
            {d.Name}
        </NavLink></NavItem>);



        return (
            <>
                {this.state.showBanner && (<Banner Close={this.closeBanner} message={this.state.message} IsSuccess={this.state.IsSuccess} />)}
                <div style={{ marginLeft: "5%", marginRight: "5%" }} className="form-row mb-3">
                <Card className="col-12">
                    <CardBody>
                            <CardTitle><strong>Property Address</strong></CardTitle>
                            <CardBody className="pl-0">{this.state.OrderData.Address}</CardBody>
                    </CardBody>
                </Card>
            </div>
                <div style={{ marginLeft: "5%", marginRight: "5%" }} className="card pl-2 pt-2">
                <Nav pills >
                    {proptabitem}
                    </Nav>
                    <hr/>
                <TabContent activeTab={this.state.activeTab}>
                        <TabPane tabId="1">
                            {this.state.activeTab === '1' && <PropertyReportMain banner={this.showBanner} OrderId={this.props.location.Order.Id} OrderProductId={this.props.location.Order.OrderProductId}/>}
                    </TabPane>                                                
                    <TabPane tabId="2">                                       
                        {this.state.activeTab === '2' && (<PropertyReportDeedMain   banner={this.showBanner} OrderId={this.props.location.Order.Id} OrderProductId={this.props.location.Order.OrderProductId}/>)}
                    </TabPane>
                    <TabPane tabId="3">
                        {this.state.activeTab === '3' && (<PropertyReportMrtgMain  banner={this.showBanner} OrderId={this.props.location.Order.Id} OrderProductId={this.props.location.Order.OrderProductId}/>)}
                    </TabPane>
                    <TabPane tabId="5">
                        {this.state.activeTab === '5' && (<PropertyReportLienMain  banner={this.showBanner} OrderId={this.props.location.Order.Id} OrderProductId={this.props.location.Order.OrderProductId}/>)}
                    </TabPane>
                    <TabPane tabId="6">
                        {this.state.activeTab === '6' && (<PropertyReportTaxMain banner={this.showBanner} OrderId={this.props.location.Order.Id} OrderProductId={this.props.location.Order.OrderProductId}/>)}
                    </TabPane>
                    
                </TabContent>
                </div>
                </>
        )
    }
}

export default (PropertyRerportForm);